import React, { useState } from 'react';
import { productRangeManagementStore } from '../../data/states/product_range_management_store.ts';
import { Button, CircularProgress, Typography } from '@mui/material';
import { Align, Alignment } from '../../components/atoms/align.tsx';
import { CreateProductFacetModal } from './components/create_product_facet_model.tsx';
import { FloatingActionButton } from '../../components/atoms/floating_action_button.tsx';
import { Add } from '@mui/icons-material';
import { ProductRange } from '../../data/entities/product_range.ts';
import { LocalisedCanonicalList } from './components/localised_canonical_list.tsx';

export const ProductRangeTab: React.FC = () => {
    const { productRanges, createProductRange, deleteProductRange, retry } = productRangeManagementStore(
        (state) => state,
    );
    const [modalIsVisible, setModalIsVisible] = useState(false);

    return productRanges.when(
        (data: ProductRange[]) => {
            return <>
                <Align
                    alignment={Alignment.top}
                >
                    <LocalisedCanonicalList
                        title="Product ranges"
                        items={data}
                        deleteItem={async (feature) => {
                            await deleteProductRange(feature._id);
                        }}
                    />
                </Align>
                <CreateProductFacetModal
                    facetName='Product range'
                    visible={modalIsVisible}
                    onSubmit={(value: string) => {
                        createProductRange(value).then(
                            (v) => {
                                setModalIsVisible(false);
                            }
                        ).catch(
                            (e) => {
                                alert(e);
                            }
                        );
                    }}
                    onClose={() => {
                        setModalIsVisible(false);
                    }}
                />
                <FloatingActionButton
                    onClick={() => {
                        setModalIsVisible(true);
                    }}
                >
                    <Add />
                </FloatingActionButton>
            </>;
        },
        (error: Error) => {
            return <Align
                alignment={Alignment.center}
            >
                <div>
                    <Typography
                        variant='h5'
                        sx={{
                            pb: "16px"
                        }}
                    >
                        Error fetching product ranges
                    </Typography>
                    <Align
                        alignment={Alignment.center}
                    >
                        <Button
                            variant='contained'
                            onClick={retry}
                            sx={{
                                width: "120px"
                            }}
                        >
                            RETRY
                        </Button>
                    </Align>
                </div>
            </Align >
        },
        () => {
            return <Align
                alignment={Alignment.center}
            >
                <CircularProgress />
            </Align>;
        },
    );
};